import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function PricingSection() {
  return <section id="pricing" className="py-24 bg-white relative overflow-hidden" data-id="element-152">
      <div className="container mx-auto px-6 max-w-3xl text-center relative z-10" data-id="element-153">
        <FadeIn data-id="element-154">
          <div className="bg-cream rounded-3xl p-8 md:p-12 shadow-warm-lg border border-cream-dark/50" data-id="element-155">
            <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-charcoal" data-id="element-156">
              Por menos de lo que cuesta una cena…
            </h2>
            <p className="text-xl md:text-2xl text-charcoal-light mb-12 font-medium" data-id="element-157">
              Puedes empezar a recuperar tu sueño esta misma noche.
            </p>

            <div className="mb-10" data-id="element-158">
              <span className="text-sm uppercase tracking-widest font-bold text-charcoal-muted mb-2 block" data-id="element-159">
                Valor del programa
              </span>
              <div className="flex flex-col items-center justify-center gap-1" data-id="element-160">
                <span className="text-2xl text-charcoal-muted line-through decoration-charcoal-muted/50" data-id="element-161">
                  44,99€
                </span>
                <span className="text-5xl md:text-6xl font-serif font-bold text-charcoal" data-id="element-162">
                  6,61€
                </span>
                <span className="text-sm text-charcoal-muted" data-id="element-163">
                  IVA incluido
                </span>
              </div>
            </div>

            <p className="mb-6 text-lg md:text-xl font-serif italic text-charcoal-light" data-id="element-164">
              Si esta noche vuelves a despertarte a las 3am… vas a seguir igual
              mañana.
            </p>

            <CTAButton text="QUIERO RECUPERAR MI SUEÑO ESTA MISMA NOCHE" className="!bg-cream-dark !text-charcoal !shadow-[0_6px_0_#d4c4b0,0_15px_20px_rgba(45,42,38,0.1)] active:!shadow-[0_0px_0_#d4c4b0,0_0px_0_rgba(45,42,38,0.1)]" data-id="element-165" />

            <p className="mt-4 text-base font-bold text-charcoal" data-id="element-166">
              Empiezas hoy. Notas cambios en días.
            </p>
            <p className="mt-2 text-sm text-charcoal-muted" data-id="element-167">
              Pago único y seguro con Hotmart · Acceso inmediato · Garantía 7
              días sin preguntar.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}